module.exports = [{
      plugin: require('D:/coding/renome-restaurant/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
